// This import loads the firebase namespace along with all its type information.
import CustomerSettings from './customer-settings-model'

export async function load_customerSettingss(): Promise<CustomerSettings[]> {
  throw 'Not implemented'
}

export async function delete_customerSettings(): Promise<boolean> {
  throw 'Not implemented'
}

export async function store_customerSettings(): Promise<CustomerSettings> {
  throw 'Not implemented'
}
